import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OtpService } from '../../../services/otp.service';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-ingresar-correo-otp',
  templateUrl: './ingresar-correo-otp.component.html',
  styleUrls: ['./ingresar-correo-otp.component.scss'],
})
export class IngresarCorreoOtpComponent implements OnInit {
  formularioCorreo: FormGroup;
  enviado = false;
  mensajeError = '';
  cargando = false;
  tramiteId: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private otpService: OtpService
  ) {
    this.formularioCorreo = this.fb.group({
      correo: ['', [Validators.required, 
        Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO)]],
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.tramiteId = params['id'] ?? '';
    });
  }

  enviarCodigoOTP(): void {
    this.enviado = true;
    this.mensajeError = '';
    this.cargando = true;

    if (this.formularioCorreo.invalid) {
      this.cargando = false;
      return;
    }

    const correo = this.formularioCorreo.value.correo;

    this.otpService.enviarOtp(correo, this.tramiteId).subscribe({
      next: () => {
        this.cargando = false;
        this.router.navigate(['/verificar-otp'], {
          queryParams: { correo, id: this.tramiteId },
        });
      },
      error: err => {
        this.cargando = false;
        this.mensajeError =
          'No fue posible enviar el código. Intenta nuevamente.';
        console.error('Error al enviar OTP:', err);
      },
    });
  }
}
